import ReactOnRails from 'react-on-rails/client';
import ShopsSessionsNew from '../../shops/sessions/new/ror_components/ShopsSessionsNew.tsx';

ReactOnRails.register({ShopsSessionsNew});